<template>
  <div class="line">
    <div :class="['auto', { active: useTips }]">
      <template v-if="canChangeTips" >
        <span @click="$emit('change:tips', !useTips)">Ответ</span>
        <button @click="$emit('change:tips', !useTips)">
          <IconGraduationCap size="24" color="#4D43C6"/>
        </button>  
      </template>
    </div>

    <div :class="['help', { limit: reachedLimit, active: useHelp }]" @click="changeHelp">
      <span>Открыть слово</span>
      <b>{{ current }}/{{ max }}</b>
      <IconLightbulb size="24" color="#4D43C6"/>
    </div>
  </div>
</template>


<script>
import IconLightbulb from '@/components/icons/IconLightbulb';
import IconGraduationCap from '@/components/icons/IconGraduationCap';

export default {
  name: 'HelpToolbar',

  components: {
    IconLightbulb,
    IconGraduationCap,
  },

  props: {
    canChangeTips: Boolean,
    useTips: Boolean,
    useHelp: Boolean,
    useAuto: Boolean,
    current: Number,
    max: Number,
  },

  computed: {
    reachedLimit: ths => ths.current >= ths.max,
  },

  methods: {
    changeHelp() {
      if (this.reachedLimit) {
        this.$metrika.add(
          this.$metrika.consts.GAME_USE_HELP_LAMP,
          { game: { words: { usedHelps: 'limit' } } },
        );
        return this.$bus.$emit('showNotification', {
          message: 'Превышено количество разрешенных подсказок!',
          status: 'danger-game',
        });
      };

      if (this.useHelp) {
        this.$metrika.add(
          this.$metrika.consts.GAME_USE_HELP_LAMP,
          { game: { words: { usedHelps: 'cancel' } } },
        );
        this.$bus.$emit('showNotification', {
          message: 'Режим подсказки отключен!',
          status: 'success',
        });
      } else {
        this.$bus.$emit('showNotification', {
          message: 'Выберите ячейку, которую хотите открыть!',
          status: 'success',
        });
      };
      this.$emit('change:help', !this.useHelp);
    },

    changeAuto() {
      if (this.useAuto) {
        this.$bus.$emit('showNotification', {
          message: 'Режим автоматической подстановки отключен!',
          status: 'success',
        });
      } else {
        this.$bus.$emit('showNotification', {
          message: 'Теперь слова будет подставляться автоматически!',
          status: 'success',
        });
      };
      this.$emit('change:auto', !this.useAuto);
    },
  },
};
</script>


<style lang="scss" scoped>
.line {
  display: flex;
  justify-content: space-between;
  color: #4D43C6;
  align-items: center;
  font-weight: bold;
  font-family: Arial;
  user-select: none;
  gap: 5px;

  button {
    border: none;
    padding: 0;
    background: transparent;
    cursor: pointer;
  }

  .auto {
    cursor: pointer;
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    gap: 5px;
  }

  .help {
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 5px;

    &.limit {
      opacity: 0.5;
    }

    span {
      color: var(--color-primary);
    }
  }
}
</style>